import { IconButton } from '@alto-avios/alto-ui';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Dialog, DialogTrigger, Modal } from 'react-aria-components';

import { HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { Logo } from '../Logo';
import { HeaderContent, useRequiredContent } from '../services/content';

import styles from './Overlay.module.scss';
import { useOverlayContext } from './useOverlayContext.ts';

export interface OverlayProps {
  children: ReactNode;
  ariaLabel: string;
  trigger: ReactNode;
}

export const OverlayContent = ({ children }: PropsWithChildren) => {
  const {
    data: { burgerMenuCloseAriaLabel, logo },
  } = useRequiredContent(HeaderContent);
  const overlayContext = useOverlayContext();

  const onAviosLogoClick = () => {
    overlayContext?.close();
    pushGTMEvent(HEADER, 'Avios logo');
  };

  return (
    <>
      <div className={styles.header}>
        <Logo imageData={logo} onPress={onAviosLogoClick} variant={HEADER} />
        <IconButton
          aria-label={burgerMenuCloseAriaLabel}
          emphasis="quaternary"
          iconProps={{ iconName: 'times' }}
          onClick={overlayContext?.close}
          styleVariant="neutral"
        />
      </div>
      <div className={styles.overlayBody}>{children}</div>
    </>
  );
};

export const Overlay: FC<OverlayProps> = ({ children, ariaLabel, trigger }) => {
  return (
    <DialogTrigger>
      {trigger}
      <Modal className={styles.overlay}>
        <Dialog className={styles.dialog} aria-label={ariaLabel}>
          <OverlayContent>{children}</OverlayContent>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
